import { default as Circle, CircleProps } from "./Circle";
import React from "react";
import InitialDisplay from "./InitialDisplay";
import { FaUserSlash } from "react-icons/fa";

export type UserProfileImageProps = {
  profileImage?: string | null;
  name: string;
} & CircleProps;

export const UserProfileImage = ({
  profileImage,
  name,
  className,
  ...props
}: UserProfileImageProps) => {
  // "cc-avatar" lets a link around an avatar skip underlining it on hover
  // (see the apps' GlobalStyle).
  const rest = {
    ...props,
    className: className ? `cc-avatar ${className}` : "cc-avatar",
  };

  return name === "Deleted User" ? (
    <Circle title={name} icon={FaUserSlash} {...rest} />
  ) : profileImage ? (
    <Circle
      title={name}
      image={`${process.env.REACT_APP_STATIC_ROOT}/${profileImage}`}
      {...rest}
    />
  ) : (
    <InitialDisplay title={name} text={name} {...rest} />
  );
};

export default UserProfileImage;
